import { ConstructObservable, IS_OBSERVABLE_CONSTRUCTOR, IS_OBSERVABLE_LIKE_CONSTRUCTOR } from './constructor';
import { ObservableIsObserved } from './functions';
import { MakeFactory } from '../../classes/class-helpers/factory';
import { BaseClass } from '../../classes/class-helpers/base-class';
import { Observer } from '../observer/implementation';
import { OBSERVABLE_PRIVATE } from './privates';
import { ReadonlyList } from '../../misc/readonly-list/implementation';
import { IsObserver } from '../observer/constructor';
export function ObservableGetObservers(instance) {
    const privates = instance[OBSERVABLE_PRIVATE];
    if (privates.readOnlyObservers === void 0) {
        privates.readOnlyObservers = new ReadonlyList(privates.observers);
    }
    return privates.readOnlyObservers;
}
export function ObservablePipeTo(instance, observerOrCallback) {
    let observer;
    if (typeof observerOrCallback === 'function') {
        observer = new Observer(observerOrCallback);
    }
    else if (IsObserver(observerOrCallback)) {
        observer = observerOrCallback;
    }
    else {
        throw new TypeError(`Expected Observer or function.`);
    }
    return observer.observe(instance);
}
export function ObservableObservedBy(instance, observers) {
    for (let i = 0, l = observers.length; i < l; i++) {
        ObservablePipeTo(instance, observers[i]);
    }
}
export function ObservableClearObservers(instance) {
    const privates = instance[OBSERVABLE_PRIVATE];
    while (privates.observers.length > 0) {
        privates.observers[0].unobserve(instance);
    }
}
function PureObservableFactory(superClass) {
    return class Observable extends superClass {
        constructor(...args) {
            const [create] = args[0];
            super(...args.slice(1));
            ConstructObservable(this, create);
        }
        get observers() {
            return ObservableGetObservers(this);
        }
        get observed() {
            return ObservableIsObserved(this);
        }
        pipeTo(observerOrCallback) {
            return ObservablePipeTo(this, observerOrCallback);
        }
        pipeThrough(observableObserver) {
            ObservablePipeTo(this, observableObserver.observer);
            return observableObserver.observable;
        }
        pipe(observableObserver) {
            ObservablePipeTo(this, observableObserver.observer);
            return observableObserver;
        }
        observedBy(...observers) {
            ObservableObservedBy(this, observers);
            return this;
        }
        clearObservers() {
            ObservableClearObservers(this);
            return this;
        }
    };
}
export let Observable;
export function ObservableFactory(superClass) {
    return MakeFactory(PureObservableFactory, [], superClass, {
        name: 'Observable',
        instanceOf: Observable,
        waterMarks: [IS_OBSERVABLE_CONSTRUCTOR, IS_OBSERVABLE_LIKE_CONSTRUCTOR]
    });
}
Observable = class Observable extends ObservableFactory(BaseClass) {
    constructor(create) {
        super([create]);
    }
};
//# sourceMappingURL=implementation.js.map